import { ReactNode, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import styles from "./style.module.scss";
import PrintPage, { EXPORT_PDF_QUERY_PARAM } from "@components/print/PrintElements/PrintPage";
import PrintPageHeader from "@components/print/PrintElements/PrintPageHeader";
import { useAppSelector } from "@/store/hooks";
import PrintDocumentHeader from "@components/print/PrintElements/PrintDocumentHeader";
import { RecibeApi, RecibeDataType } from "@/api/RecibeApi";
import { RecibeFormDataKeys } from "@/generated/RecibeFormDataKeys";
import { RecibeRelatedAttributes } from "@/formTypes/RecibeDataType";
import { formatDate } from "@utils/Api";
import { getPaymentMethodLabel } from "@utils/Utils";
import { formatMoneyValue } from "@utils/Currency";
import { CHEQUE_PAYMENT_WAY_CODE, CURRENCIES_CODES, SINPE_PAYMENT_WAY_CODE, TRANSFER_PAYMENT_WAY_CODE } from "@utils/Constants";
import cx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { numberToWords } from "@utils/Recibe";
import { checkRecibeTicketPrint } from "@utils/ticketPrintUtils";
import { PrintPageDataLoadedPubSub } from "@utils/pubsubs/PubSub";


const RecibePrint = () => {
  const params = useParams()
  const { id: recibeId, autoPrint = false, copies = 0 } = params;
  const [searchParams] = useSearchParams();
  const exportFlag = searchParams.get(EXPORT_PDF_QUERY_PARAM);

  const suscription = useAppSelector((state) => { return state.suscription.suscription });
  const [recibe, setRecibe] = useState<RecibeDataType>({})

  useEffect(() => {
    import("@printerVariation/generic.scss");
    PrintPageDataLoadedPubSub.publish({ dataLoaded: false })
    loadRecibeData()
  }, []);

  useEffect(() => {
    if (!exportFlag && autoPrint && suscription?.id && recibe?.id) {
      checkRecibeTicketPrint(suscription, recibe)
    }
  }, [suscription?.id, recibe?.id]);

  const loadRecibeData = async () => {
    if (recibeId) {
      const recibe = await RecibeApi.get(recibeId, {
        selectionSet: [
          ...RecibeFormDataKeys.filter(k => !RecibeRelatedAttributes.includes(k)),
          "currency.*",
          "client.*",
          "creditOperator.*",
          "bankAccount.*"
        ]
      })
      setRecibe(recibe)
    }
    PrintPageDataLoadedPubSub.publish({ dataLoaded: true })
  }

  const renderPaymentWay = () => {
    let additionalInfo = "";
    const paymentWayLabel = getPaymentMethodLabel(recibe.forma_pago)
    if (recibe.forma_pago == `${TRANSFER_PAYMENT_WAY_CODE}`) {
      additionalInfo = ` #${recibe.reference} Banco ${recibe.bankAccount?.title} ${CURRENCIES_CODES[recibe.bankAccount?.moneda]}`;
    } else if (recibe.forma_pago == `${CHEQUE_PAYMENT_WAY_CODE}`) {
      additionalInfo = ` #${recibe.reference} Banco ${recibe.bankAccount?.title} ${CURRENCIES_CODES[recibe.bankAccount?.moneda]}`;
    } else if (recibe.forma_pago == `${SINPE_PAYMENT_WAY_CODE}`) {
      additionalInfo = ` #${recibe.reference} Banco ${recibe.bankAccount?.title} ${CURRENCIES_CODES[recibe.bankAccount?.moneda]}`;
    }
    return (
      <div>
        <div className={styles.cuadro}>x</div> {paymentWayLabel} {additionalInfo}
      </div>
    )
  }

  const renderPage = (): ReactNode => {
    return (
      <PrintPage
        nula={recibe.anulado || false}
        autoPrint={autoPrint === "1"}
        copies={Number(copies)}
      >
        <PrintPageHeader suscription={suscription} />
        <div className={styles.pageContent}>
          <PrintDocumentHeader
            title={`Recibo #${recibe.numero} `}
            fecha={formatDate(recibe.created, "YYYY-MM-DD", "DD.MM.YY")} />
          <div className={styles.info}>
            <div className={styles.clienteDetails}>
              <div className={styles.iconClient}>
                <FontAwesomeIcon icon={faUser} />
              </div>
              <div className={styles.clientes}>
                <div><span className={styles.clientTitle} >Recibimos de : </span> {recibe.nombre || recibe.client.nombre}</div>
                <div><span className={styles.clientTitle}>La suma de : </span> {numberToWords(Number(recibe.abono || 0), recibe.currency.currency_id)} </div>
                <div><span className={cx([styles.clientTitle, styles.concepto])}>Por Concepto de : </span> {recibe.motivo}</div>
              </div>
            </div>
            <div className={styles.totalWrapper}>
              <div className={styles.totalTitle}>Saldo:</div><div className={styles.totalAmount}> {formatMoneyValue(recibe.total, recibe.currency.currency_id)} </div>
              <div className={styles.totalTitle}>Abono:</div><div className={styles.totalAmount}> {formatMoneyValue(recibe.abono, recibe.currency.currency_id)} </div>
              <div className={styles.totalTitle}>Saldo:</div><div className={styles.totalAmount}> {formatMoneyValue((Number(recibe.total || 0) - Number(recibe.abono || 0)), recibe.currency.currency_id)} </div>
            </div>

            <div className={styles.clearFix}>
              <div className={styles.formasPago}>
                <div className="tipos">
                  <p>Forma de pago</p>
                  <div className={styles.formasPagoWrapper}>
                    {renderPaymentWay()}
                  </div>
                </div>

              </div>
              <div className={styles.signature}>______________________________________________________<br />Firma Responsable</div>
            </div>
          </div>
          <br />
          <p style={{
            textAlign: "center",
            fontSize: "12px",
            marginBottom: "15px"
          }}>Autorizado mediante Oficio #1197 de la D.G.T publicada en la Gaceta # 171 del 5-9-97           </p>

        </div>
      </PrintPage >
    )
  }

  return (
    <div>
      {recibe?.id && renderPage()}
      {!recibe.id && (
        <h3>Cargando </h3>
      )}

    </div>
  );
}

export default RecibePrint;
